module.exports = __webpack_public_path__ + "static/media/psychedelics.b43298bd.svg";